function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import throttle from '@/utils/throttle';
import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
export default {
  data: function data() {
    return {
      selectCompany: '',
      options: []
    };
  },
  props: {
    initCompanyId: [Number, String],
    outName: {
      type: Boolean,
      default: false
    },
    companyList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    initCompanyId: {
      handler: function handler(val) {
        var searchKey = this.initCompanyId;
        if (this.outName) {
          var _ref = this.initCompanyId && this.initCompanyId.split('_') || [],
            _ref2 = _slicedToArray(_ref, 2),
            id = _ref2[0],
            name = _ref2[1];
          searchKey = name;
        }
        ;
        this.getCompanyList(searchKey, true);
      },
      immediate: true,
      deep: true
    },
    companyList: {
      handler: function handler(val) {
        if (val && val.length > 0) {
          console.log('使用父组件提供的公司列表:', val);
          this.options = val;
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // 如果没有传入公司列表，则从API获取
    if (!this.companyList || this.companyList.length === 0) {
      this.getCompanyList('', true);
    }
  },
  methods: {
    throttle: throttle,
    changeSelect: function changeSelect(e) {
      if (!e) {
        // 如果没有传入公司列表，则从API获取
        if (!this.companyList || this.companyList.length === 0) {
          this.getCompanyList('');
        }
      }
      ;
      this.$emit('selectCompany', e);
      this.$emit('change', e);
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this = this;
      // 如果有传入公司列表，则在本地过滤
      if (this.companyList && this.companyList.length > 0) {
        if (!data) {
          this.options = this.companyList;
        } else {
          this.options = this.companyList.filter(function (item) {
            return item.name && item.name.toLowerCase().includes(data.toLowerCase());
          });
        }
        return;
      }

      // 否则从API获取
      this.throttle(function () {
        _this.getCompanyList(data);
      }, 300)();
    },
    getCompanyList: function getCompanyList(key) {
      var _this2 = this;
      var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // 如果有传入公司列表，则不需要从API获取
      if (this.companyList && this.companyList.length > 0) {
        return;
      }
      suplierCouponsApi.getAllCompany(key).then(function (res) {
        _this2.options = res || [];
        if (isInit) {
          _this2.selectCompany = _this2.initCompanyId || '';
        }
      });
    }
  }
};